<template>
	<div>
		<div class="row gutter-sm">
			<div class="col-xs-12 col-sm-12">
				<span class="q-headline text-weight-light">{{ $t('request_details') }}</span>
			</div>

			<div class="col-xs-12 col-sm-6">
				<q-input v-model="order_number" :float-label="$t('order_number')" disable />
			</div>

			<div class="col-xs-12 col-sm-6">
				<q-input v-model="reward_title" :float-label="$t('reward_title')" disable />
			</div>

			<div class="col-xs-12 col-sm-6">
				<q-input v-model="reward_type" :float-label="$t('reward_type')" disable />
			</div>

			<div class="col-xs-12 col-sm-6">
				<q-input v-model="price" :float-label="$t('price')" disable />
			</div>

			<div class="col-xs-12 col-sm-12" v-if="reward_redeen_code != null">
				<q-input
					v-model="reward_redeen_code"
					:float-label="$t('reward_redeen_code')"
					disable
				/>
			</div>

			<div class="col-xs-12 col-sm-6">
				<q-input v-model="created_date" :float-label="$t('created_date')" disable />
			</div>

			<div class="col-xs-12 col-sm-6">
				<q-input v-model="updated_date" :float-label="$t('updated_date')" disable />
			</div>

			<div class="col-xs-12 col-sm-12">
				<span class="q-headline text-weight-light">{{ $t('requester_data') }}</span>
			</div>

			<div class="col-xs-12 col-sm-12">
				<q-input v-model="full_name" :float-label="$t('full_name')" disable />
			</div>

			<div class="col-xs-12 col-sm-12">
				<q-input v-model="email" :float-label="$t('email')" disable />
			</div>

			<div class="col-xs-12 col-sm-12">
				<div class="row gutter-xs">
					<div class="col-3">
						<q-input
							v-model="phone_mobile.country_code"
							:float-label="$t('country_code')"
							disable
						/>
					</div>

					<div class="col-3">
						<q-input
							v-model="phone_mobile.area_code"
							:float-label="$t('city_code')"
							disable
						/>
					</div>

					<div class="col-6">
						<q-input
							v-model="phone_mobile.phone"
							:float-label="$t('phone_mobile')"
							disable
						/>
					</div>
				</div>
			</div>

			<div class="col-xs-12 col-sm-12 q-mt-lg flex justify-between">
				<span class="q-headline text-weight-light">{{ $t('requester_address') }}</span>
			</div>

			<div v-if="keyGooogleMaps" class="col-xs-12 col-sm-12">
				<q-field
					:error="show_maps_alert"
					:error-label="
						$t(
							'not_found_check_that_the_search_is_spelled_correctly_Try_adding_a_city_state_or_zip_code'
						)
					"
				>
					<q-input
						v-model="address"
						:float-label="$t('address')"
						autocomplete="new-password"
						:placeholder="$t('search_by_name_and_street_number')"
						:error="$v.address.$error"
						@input="$v.address.$touch"
					>
						<q-autocomplete
							@search="getAddressGoogleMaps"
							:min-characters="3"
							@selected="selectedAddressGoogleMaps"
							separator
						/>
					</q-input>
				</q-field>
			</div>

			<div v-else class="col-xs-12 col-sm-12">
				<q-input
					v-model="address"
					:float-label="$t('address')"
					autocomplete="new-password"
					:error="$v.address.$error"
					@input="$v.address.$touch"
				>
					<q-autocomplete
						@search="getAddress"
						:min-characters="3"
						@selected="selectedAddress"
						separator
					/>
				</q-input>
			</div>

			<div class="col-xs-12 col-sm-4">
				<q-input
					v-model="number"
					:float-label="$t('number')"
					ref="number"
					:error="$v.number.$error"
					@input="$v.number.$touch"
				/>
			</div>

			<div class="col-xs-12 col-sm-4">
				<q-input v-model="complement" :float-label="$t('complement')" />
			</div>

			<div class="col-xs-12 col-sm-4">
				<q-input
					v-model="neighborhood"
					:float-label="$t('neighborhood')"
					:error="$v.neighborhood.$error"
					@input="$v.neighborhood.$touch"
				/>
			</div>

			<div class="col-xs-12 col-sm-4">
				<q-input
					v-model="postal_code"
					:float-label="$t('postal_code')"
					:error="$v.postal_code.$error"
					@input="$v.postal_code.$touch"
				/>
			</div>

			<div class="col-xs-12 col-sm-4">
				<q-input
					v-model="city"
					:float-label="$t('city')"
					:error="$v.city.$error"
					@input="$v.city.$touch"
				/>
			</div>

			<div class="col-xs-12 col-sm-4">
				<q-input
					v-model="state"
					:float-label="$t('state')"
					:error="$v.state.$error"
					@input="$v.state.$touch"
				/>
			</div>
		</div>
		<div class="row justify-between q-mt-lg">
			<q-chip square :icon="getIconStatus(status)" :color="getColorStatus(status)">
				{{ $t(getStatus(status)) }}
			</q-chip>
			<q-btn
				color="secondary"
				icon="far fa-save"
				:label="$t('save_address')"
				@click="saveAddress()"
			/>
		</div>

		<div class="row gutter-sm justify-end q-mt-lg">
			<div class="col-xs-12 col-sm-3" :class="getOrder('cancel')" v-if="status === 1">
				<q-btn
					:color="getButtonColorTwo(status)"
					class="full-width"
					:label="$t(getButtonTwo(status))"
					:icon="getButtonIconTwo(status)"
					@click="alterStatus((value = 3))"
				/>
			</div>

			<div class="col-xs-12 col-sm-3" :class="getOrder('save')" v-if="status === 1">
				<q-btn
					:color="getButtonColorOne(status)"
					class="full-width"
					:label="$t(getButtonOne(status))"
					:icon="getButtonIconOne(status)"
					@click="alterStatus((value = 2))"
				/>
			</div>

			<div class="col-xs-12 col-sm-3" :class="getOrder('save')" v-if="historys.length > 0">
				<q-btn
					color="primary"
					class="full-width"
					:label="$t('status_history')"
					icon="far fa-eye"
					@click="show_timeline = true"
				/>
			</div>

			<div class="col-xs-12 col-sm-3" :class="getOrder('save')" v-if="status === 2">
				<q-btn
					:color="getButtonColorOne(status)"
					class="full-width"
					:label="$t(getButtonOne(status))"
					:icon="getButtonIconOne(status)"
					@click="alterStatus((value = 4))"
				/>
			</div>

			<div class="col-xs-12 col-sm-3" :class="getOrder('save')" v-if="status === 4">
				<q-btn
					:color="getButtonColorTwo(status)"
					class="full-width"
					:label="$t(getButtonTwo(status))"
					:icon="getButtonIconTwo(status)"
					@click="alterStatus((value = 5))"
				/>
			</div>
		</div>

		<q-modal
			v-model="show_timeline"
			:content-css="{
				minWidth: getMinWidth,
				maxWidth: getMaxWidthComment,
				minHeight: '30vh',
			}"
			no-backdrop-dismiss
			no-esc-dismiss
		>
			<q-modal-layout>
				<q-toolbar slot="header">
					<q-btn flat round dense @click="show_timeline = false" icon="fas fa-times" />
					<q-toolbar-title>
						{{ $t('timeline_status') }}
					</q-toolbar-title>
				</q-toolbar>

				<div class="layout-padding">
					<q-timeline responsive color="secondary" style="padding: 0 15px;">
						<q-timeline-entry heading>{{ $t('status_history') }}</q-timeline-entry>

						<q-timeline-entry
							v-for="history in historys"
							:key="history.id"
							:title="$t(getStatus(history.status))"
							:subtitle="getDateFormated(history.created_date)"
							side="right"
							:color="getColorStatus(history.status)"
							:icon="getIconStatus(history.status)"
						>
							<div>
								<span class="q-mt-none q-md-none">{{ history.user_full_name }}</span
								><br />
								<span class="text-weight-thin q-mt-none">{{
									history.user_email
								}}</span
								><br />
								<p class="text-weight-light q-mt-md">
									<i>{{ history.observation }}</i>
								</p>
							</div>
						</q-timeline-entry>
					</q-timeline>
				</div>
			</q-modal-layout>
		</q-modal>

		<q-modal
			v-model="show_comment_status"
			:content-css="{
				minWidth: getMinWidth,
				maxWidth: getMaxWidth,
				minHeight: '50vh',
				maxHeight: '70vh',
			}"
			no-backdrop-dismiss
			no-esc-dismiss
		>
			<q-modal-layout>
				<q-toolbar slot="header">
					<q-btn
						flat
						round
						dense
						@click="show_comment_status = false"
						icon="fas fa-times"
					/>
					<q-toolbar-title> {{ $t('status_comment') }}* </q-toolbar-title>
				</q-toolbar>

				<div class="layout-padding">
					<div class="row">
						<div class="col-12">
							{{ $t('do_you_really_want_to_perform_this_action') }}
						</div>
						<div class="col-12">
							<q-input
								type="textarea"
								rows="5"
								:float-label="$t('comment')"
								v-model="comment_status"
								:error="$v.comment_status.$error"
								@input="$v.comment_status.$touch"
							/>
						</div>
					</div>

					<div class="row gutter-sm justify-end q-mt-lg">
						<div class="col-xs-12 col-sm-3" v-if="statuses === 2">
							<q-btn
								:color="getButtonColorOne(status)"
								class="full-width"
								:label="$t(getButtonOne(status))"
								:icon="getButtonIconOne(status)"
								@click="saveData()"
							/>
						</div>
						<div class="col-xs-12 col-sm-3" v-if="statuses === 3">
							<q-btn
								:color="getButtonColorTwo(status)"
								class="full-width"
								:label="$t(getButtonTwo(status))"
								:icon="getButtonIconTwo(status)"
								@click="saveData()"
							/>
						</div>
						<div class="col-xs-12 col-sm-3" v-if="statuses === 4">
							<q-btn
								:color="getButtonColorOne(status)"
								class="full-width"
								:label="$t(getButtonOne(status))"
								:icon="getButtonIconOne(status)"
								@click="saveData()"
							/>
						</div>
						<div class="col-xs-12 col-sm-3" v-if="statuses === 5">
							<q-btn
								:color="getButtonColorTwo(status)"
								class="full-width"
								:label="$t(getButtonTwo(status))"
								:icon="getButtonIconTwo(status)"
								@click="saveData()"
							/>
						</div>
					</div>
				</div>
			</q-modal-layout>
		</q-modal>
	</div>
</template>

<script>
import { mapGetters } from 'vuex'
import { required, requiredIf } from 'vuelidate/lib/validators'
import { date } from 'quasar'
import { OpenStreetMapProvider } from 'leaflet-geosearch'
const provider = new OpenStreetMapProvider({
	params: {
		addressdetails: '1',
	},
})
export default {
	i18nOptions: { namespaces: ['custom', 'common', 'profile', 'training', 'admin', 'rewards'] },
	data() {
		return {
			show_maps_alert: false,
			server_pagination: {
				page: 1,
				rowsNumber: 10,
				rowsPerPage: 5,
				descending: false,
				sortBy: null,
			},
			action_id: '',
			loading: false,
			id_redeem: '',
			order_number: '',
			reward_title: '',
			reward: '',
			reward_type: '',
			full_name: '',
			email: '',
			phone_mobile: {},
			address: '',
			number: '',
			complement: '',
			neighborhood: '',
			postal_code: '',
			country: '',
			city: '',
			state: '',
			lat: 0,
			long: 0,
			price: '',
			created_date: '',
			updated_date: '',
			reward_redeen_code: '',
			historys: [],
			user_points: [],
			status: 1,
			comment_status: '',
			show_comment_status: false,
			show_timeline: false,
			statuses: '',
			statusToogle: '',
			progress_status: '',
		}
	},
	computed: {
		...mapGetters({
			access_token: 'common/access_token',
			areas: 'registration_lists/country_areas',
			reload_content: 'common/reload_content',
			reward_types: 'registration_lists/reward_types',
			reward_categories: 'registration_lists/reward_categories',
		}),

		getHeader() {
			let headers = {}
			return (headers = {
				headers: {
					'content-type': 'application/json',
					authorization:
						'Basic ' +
						btoa(process.env.APP_CLIENT_ID + ':' + process.env.APP_CLIENT_SECRET),
					authorization: 'Bearer ' + this.access_token,
				},
			})
		},

		showTab() {
			if (this.id_news != 0) return true
			else return false
		},

		keyGooogleMaps() {
			return process.env.KEY_GOOGLE_API
		},

		getRewardTypeTranslation() {
			return this.reward_types.map((reward) => {
				return {
					...reward,
					label: this.$t(reward.label),
				}
			})
		},

		getMaxWidth() {
			if (this.$q.platform.is.mobile) return '80vw'
			else return '50vw'
		},

		getMaxWidthComment() {
			if (this.$q.platform.is.mobile) return '80vw'
			else return '50vw'
		},

		getMinWidth() {
			if (!this.$q.platform.is.mobile) return '50vw'
			else return '85vw'
		},

		validateAddress() {
			if (this.progress_status == 2 && this.reward_redeen_code == null) {
				if (
					this.address != '' &&
					this.number != '' &&
					this.neighborhood != '' &&
					this.postal_code != '' &&
					this.city != '' &&
					this.state != '' &&
					this.address != null &&
					this.number != null &&
					this.neighborhood != null &&
					this.postal_code != null &&
					this.city != null &&
					this.state != null
				)
					return true
				else return false
			} else return true
		},
	},

	methods: {
		saveAddress() {
			this.$v.$touch()
			this.$q.loading.show()
			let data = {
				country: this.country,
				state: this.state,
				city: this.city,
				address: this.address,
				number: this.number,
				complement: this.complement,
				neighborhood: this.neighborhood,
				postal_code: this.postal_code,
				lat: this.lat,
				long: this.long,
			}
			this.$axios
				.post(
					'/admin_rewards/rewards_orders/' + this.id_redeem + '/save_user_address/',
					data,
					this.getHeader
				)
				.then(() => {
					this.$q.loading.hide()
					this.$q.notify({
						message: this.$t('address_edit_success'),
						type: 'positive',
						icon: 'fal fa-save',
					})
					this.$router.push({ name: 'reward_order', params: { id: this.id_redeem } })
				})
				.catch((e) => {
					this.$q.loading.hide()
					console.log(e)
				})
		},

		getAddress(terms, done) {
			provider.search({ query: terms }).then((result) => {
				done(result)
			})
		},

		selectedAddress(item) {
			this.$nextTick(() => (this.address = item.raw.address.road))
			this.postal_code = item.raw.address.postcode
			this.city = item.raw.address.city
			this.state = item.raw.address.state
			this.lat = item.raw.lat
			this.long = item.raw.lon
			this.country = item.raw.address.country
			if (item.raw.address.neighbourhood) {
				this.neighborhood = item.raw.address.neighbourhood
			} else if (item.raw.address.suburb) {
				this.neighborhood = item.raw.address.suburb
			} else if (item.raw.address.city_district) {
				this.neighborhood = item.raw.address.city_district
			}
			this.$nextTick(() => this.$refs.number.$el.focus())
		},

		getAddressGoogleMaps(terms, done) {
			this.$axios
				.get(
					`https://maps.googleapis.com/maps/api/geocode/json?address=${terms}&key=${
						this.keyGooogleMaps
					}`
				)
				.then((response) => {
					if (response.data.results.length > 0) {
						this.option_address = response.data.results
						let teste = response.data.results.map((e) => ({
							label: e.formatted_address,
							value: e.formatted_address,
							place_id: e.place_id,
						}))
						done(teste)
					} else {
						this.show_maps_alert = true
					}
				})
				.catch((e) => {
					console.log(e)
				})
		},

		selectedAddressGoogleMaps(item) {
			this.show_maps_alert = false
			this.address = ''
			this.postal_code = ''
			this.city = ''
			this.state = ''
			this.country = ''
			this.neighborhood = ''
			this.number = ''
			this.lat = ''
			this.long = ''
			this.option_address.map((x) => {
				if (x.place_id === item.place_id) {
					this.lat = x.geometry.location.lat
					this.long = x.geometry.location.lng
					x.address_components.map((e) => {
						switch (e.types[0]) {
							case 'route':
								this.address = e.long_name
								break
							case 'political':
							case 'administrative_area_level_4':
								this.neighborhood = e.long_name
								break
							case 'street_number':
								this.number = e.long_name
								break
							case 'postal_code':
								this.postal_code = e.long_name
								break
							case 'administrative_area_level_2':
								this.city = e.long_name
								break
							case 'country':
								this.country = e.long_name
								break
							case 'administrative_area_level_1':
								this.state = e.long_name
								break
						}
					})
				}
			})
		},

		fetchLists() {
			this.$q.loading.show()
			this.$axios
				.get('/accounts/get_registration_lists/', this.getHeader)
				.then((response) => {
					this.$store.dispatch('registration_lists/SET_LISTS', [response.data])
					this.$q.loading.hide()
				})
				.catch((e) => {
					this.$q.loading.hide()
					console.log(e)
				})
		},

		confirmRemove(id) {
			this.action_id = id
			this.confirm_remove = true
		},

		removeItem() {
			this.$q.loading.show()
			this.$axios
				.delete(
					`/admin_rewards/rewards/${this.id_reward}/redeen_codes/${this.action_id}/`,
					this.getHeader
				)
				.then(() => {
					this.$q.loading.hide()
					this.confirm_remove = false
					this.$q.notify({
						message: this.$t('item_removed_success'),
						type: 'positive',
						icon: 'far fa-trash-alt',
					})
				})
				.catch((e) => {
					this.$q.loading.hide()
					console.log(e)
				})
		},

		fetchData() {
			this.$axios
				.get('/admin_rewards/rewards_orders/' + this.id_redeem + '/', this.getHeader)
				.then((response) => {
					this.reward_title = response.data.reward_title
					this.reward = response.data.reward
					this.reward_type = this.$t(response.data.reward_type)
					this.order_number = response.data.order_number
					this.status = response.data.status
					this.full_name = response.data.full_name
					this.email = response.data.email
					this.phone_mobile = response.data.phone_mobile
					this.price = parseInt(response.data.price)
					this.address = response.data.address.address
					this.number = response.data.address.number
					this.complement = response.data.address.complement
					this.neighborhood = response.data.address.neighborhood
					this.postal_code = response.data.address.postal_code
					this.city = response.data.address.city
					this.state = response.data.address.state
					this.reward_redeen_code = response.data.reward_redeen_code
					this.historys = response.data.history
					this.created_date = date.formatDate(
						response.data.created_date,
						'DD/MM/YYYY HH:mm:ss'
					)
					this.updated_date = date.formatDate(
						response.data.updated_date,
						'DD/MM/YYYY HH:mm:ss'
					)
					this.user_points = response.user_points

					this.$store.dispatch('campaigns/SET_USER_ID', [response.data.id_user])

					this.$q.loading.hide()
				})
				.catch((e) => {
					this.$q.loading.hide()
					console.log(e)
				})
		},

		saveData() {
			this.$v.$touch()
			if (!this.$v.$error) {
				this.$q.loading.show()

				let data = {
					comment: this.comment_status,
				}

				if (this.statuses === 2) {
					this.$axios
						.post(
							'/admin_rewards/rewards_orders/' +
								this.id_redeem +
								'/approve_reward_user_order/',
							data,
							this.getHeader
						)
						.then(() => {
							this.$q.loading.hide()
							this.$q.notify({
								message: this.$t('redeem_approved_success'),
								type: 'positive',
								icon: 'fal fa-check-double',
							})
							this.show_comment_status = false
							this.comment_status = ''
							this.fetchData()
						})
						.catch((e) => {
							this.$q.loading.hide()
							console.log(e)
						})
				} else if (this.statuses === 3) {
					this.$axios
						.post(
							'/admin_rewards/rewards_orders/' +
								this.id_redeem +
								'/reprove_reward_user_order/',
							data,
							this.getHeader
						)
						.then(() => {
							this.$q.loading.hide()
							this.$q.notify({
								message: this.$t('redeem_reprove'),
								type: 'negative',
								icon: 'fal fa-times',
							})
							this.show_comment_status = false
							this.comment_status = ''
							this.fetchData()
						})
						.catch((e) => {
							this.$q.loading.hide()
							console.log(e)
						})
				} else if (this.statuses === 4) {
					this.$axios
						.post(
							'/admin_rewards/rewards_orders/' +
								this.id_redeem +
								'/send_reward_user_order/',
							data,
							this.getHeader
						)
						.then(() => {
							this.$q.loading.hide()
							this.$q.notify({
								message: this.$t('redeem_send_success'),
								type: 'positive',
								icon: 'fal fa-shipping-fast',
							})
							this.show_comment_status = false
							this.comment_status = ''
							this.fetchData()
						})
						.catch((e) => {
							this.$q.loading.hide()
							console.log(e)
						})
				} else if (this.statuses === 5) {
					this.$axios
						.post(
							'/admin_rewards/rewards_orders/' +
								this.id_redeem +
								'/received_reward_user_order/',
							data,
							this.getHeader
						)
						.then(() => {
							this.$q.loading.hide()
							this.$q.notify({
								message: this.$t('redeem_send_success'),
								type: 'positive',
								icon: 'fal fa-hand-holding-box',
							})
							this.show_comment_status = false
							this.comment_status = ''
							this.fetchData()
						})
						.catch((e) => {
							this.$q.loading.hide()
							console.log(e)
						})
				}
			} else {
				this.$q.notify({
					message: this.$t('make_sure_that_all_fields_are_filled_in'),
					type: 'negative',
					icon: 'fal fa-exclamation-triangle',
					position: 'top',
				})
			}
		},

		getErrorClass(state) {
			if (state) return 'checkbox-error'
			else return ''
		},

		getErrorColor(state) {
			if (state) return 'negative'
			else return ''
		},

		getErrorClass(state) {
			if (state) return 'checkbox-error'
			else return ''
		},

		getOrder(name) {
			if (name == 'cancel') {
				if (this.$q.platform.is.mobile) return 'order-last'
				else return 'order-first'
			} else if (name == 'save') {
				if (this.$q.platform.is.mobile) return 'order-first'
				else return 'order-last'
			}
		},

		getButtonOne(status) {
			if (status == 1) return 'approve'
			else if (status == 2) return 'ship'
			else return ''
		},

		getButtonTwo(status) {
			if (status == 1) return 'reprove'
			else if (status == 4) return 'deliver'
			else return ''
		},

		getButtonColorOne(status) {
			if (status == 1) return 'positive'
			else if (status == 2) return 'orange'
			else return ''
		},

		getButtonColorTwo(status) {
			if (status == 1) return 'negative'
			else if (status == 4) return 'light-green'
			else return ''
		},

		getButtonIconOne(status) {
			if (status == 1) return 'fal fa-check-double'
			else if (status == 2) return 'fal fa-shipping-fast'
		},

		getButtonIconTwo(status) {
			if (status == 1) return 'fal fa-times'
			else if (status == 4) return 'fal fa-hand-holding-box'
		},

		getStatus(status) {
			if (status == 1) return 'awaiting_approval'
			else if (status == 2) return 'approved'
			else if (status == 3) return 'reproved'
			else if (status == 4) return 'shipped'
			else if (status == 5) return 'delivered'
			else return ''
		},

		getIconStatus(status) {
			if (status == 1) return 'fal fa-hourglass-half'
			else if (status == 2) return 'fal fa-check-double'
			else if (status == 3) return 'fal fa-times'
			else if (status == 4) return 'fal fa-shipping-fast'
			else if (status == 5) return 'fal fa-hand-holding-box'
			else return ''
		},

		getColorStatus(status) {
			if (status == 1) return 'amber'
			else if (status == 2) return 'positive'
			else if (status == 3) return 'negative'
			else if (status == 4) return 'orange'
			else if (status == 5) return 'light-green'
			else return ''
		},

		alterStatus(value) {
			this.progress_status = value

			this.$v.$touch()
			if (!this.$v.$error) {
				this.statuses = value
				this.show_comment_status = true
			} else {
				this.$q.notify({
					message: this.$t('make_sure_that_all_fields_are_filled_in'),
					type: 'negative',
					icon: 'fal fa-exclamation-triangle',
					position: 'top',
				})
			}
		},

		getDateFormated(value) {
			let new_date = value
			let format_date = date.formatDate(new_date, 'DD/MM/YYYY HH:mm:ss')
			return format_date
		},
	},

	created() {
		this.id_redeem = this.$route.params.id
		this.statusToogle = this.status
		if (this.id_redeem != 0) this.fetchData()
		this.fetchLists()
	},

	validations() {
		return {
			address: {
				requiredIf: requiredIf(() => {
					if (this.validateAddress) return false
					else return true
				}),
			},
			comment_status: {
				requiredIf: requiredIf(() => {
					return this.show_comment_status
				}),
			},
			number: {
				requiredIf: requiredIf(() => {
					if (this.validateAddress) return false
					else return true
				}),
			},
			neighborhood: {
				requiredIf: requiredIf(() => {
					if (this.validateAddress) return false
					else return true
				}),
			},
			postal_code: {
				requiredIf: requiredIf(() => {
					if (this.validateAddress) return false
					else return true
				}),
			},
			city: {
				requiredIf: requiredIf(() => {
					if (this.validateAddress) return false
					else return true
				}),
			},
			state: {
				requiredIf: requiredIf(() => {
					if (this.validateAddress) return false
					else return true
				}),
			},
		}
	},
}
</script>
<style></style>
